import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import useActiveWorkspace from "@/hooks/useActiveWorkspace";
import { authHeader } from "@/utils/headers";

export const useDeleteDataset = (userToken: string) => {
  const queryClient = useQueryClient();
  const activeWorkspace = useActiveWorkspace();

  return useMutation(
    (datasetId: number) =>
      fetch(`${ENDPOINTS.datasets}/${datasetId}`, {
        method: "DELETE",
        headers: authHeader(userToken),
      }).then(() => undefined),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.get_datasets(activeWorkspace?.id ?? 0)]);
        queryClient.invalidateQueries([ENDPOINTS.get_dataset_groups(activeWorkspace?.id ?? 0)]);
        queryClient.invalidateQueries([ENDPOINTS.datasets]);
        queryClient.invalidateQueries([ENDPOINTS.dataset_rows]);
        queryClient.invalidateQueries([ENDPOINTS.dataset_groups]);
      },
    },
  );
};
